import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';

// COMPONENTS
import { FooterComponent } from './footer/footer.component';
import { NavbarComponent } from './navbar/navbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { NotificationSidebarComponent } from './notification-sidebar/notification-sidebar.component';

// DIRECTIVES
import { ToggleFullscreenDirective } from './directives/toggle-fullscreen.directive';
import { SidebarDirective } from './directives/sidebar.directive';
import { SidebarLinkDirective } from './directives/sidebarlink.directive';
import { SidebarListDirective } from './directives/sidebarlist.directive';
import { SidebarAnchorToggleDirective } from './directives/sidebaranchortoggle.directive';
import { SidebarToggleDirective } from './directives/sidebartoggle.directive';
import { MatDialogModule } from '@angular/material';
import { ComponentsModule } from './component/components.module';
import { PhoneNumberDirective } from './directives/phone-number.directive';
import { LettersOnlyDirective } from './directives/letters-only.directive';
import { OtpEnhancerDirective } from './directives/otp-input-enhancer.directive';
import { AlphaNumericOnlyDirective } from './directives/alpha-numeric-only.directive';


@NgModule({
    exports: [
        CommonModule,
        FooterComponent,
        NavbarComponent,
        SidebarComponent,
        NotificationSidebarComponent,
        ToggleFullscreenDirective,
        SidebarDirective,
        PhoneNumberDirective,
        LettersOnlyDirective,
        OtpEnhancerDirective,
        AlphaNumericOnlyDirective,
        NgbModule,
        TranslateModule,
        MatDialogModule,
        ComponentsModule,

    ],
    imports: [
        RouterModule,
        CommonModule,
        NgbModule,
        TranslateModule,
        PerfectScrollbarModule,
        ComponentsModule
    ],
    declarations: [
        FooterComponent,
        NavbarComponent,
        SidebarComponent,
        NotificationSidebarComponent,
        ToggleFullscreenDirective,
        SidebarDirective,
        SidebarLinkDirective,
        SidebarListDirective,
        SidebarAnchorToggleDirective,
        SidebarToggleDirective,
        PhoneNumberDirective,
        LettersOnlyDirective,
        AlphaNumericOnlyDirective,
        OtpEnhancerDirective
    ]
})
export class SharedModule { }
